import { css } from '@emotion/react';
import type { UnavailableBlockCalendarEvent } from '../../../types';
import { EventCardWrapper } from '../../column-events/event-card-wrapper';

interface Props {
  event: UnavailableBlockCalendarEvent;
}
export const UnavailableBlockEvent = ({ event }: Props) => {
  return (
    <EventCardWrapper eventType={'unavailableBlock'} containerStyle={containerStyle}>
      {event.eventType}
    </EventCardWrapper>
  );
};

const containerStyle = css({
  // TODO: use theme colors
  background: '#e5e7eb',
  color: '#374151',
});
